import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from "@/lib/lyg/string";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputWrite } from '@/pcomponents/common/date_picker/custom_input';
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";

function UserWritePopup(props: any) {
  let myProps = {
    closePopup: (inData: any) => { },
    rowData: {},
    isUpdate: false,
    ...props
  };

  const pageData = {
    "write_btn_text": "등록",
    "confirm_msg": "등록 하시겠습니까?",
  };
  if (props.isUpdate) {
    pageData["write_btn_text"] = "수정";
    pageData["confirm_msg"] = "수정 하시겠습니까?";
  }
  const [rowData, setRowData] = useState({
    "a_seq": "",
    "a_corp_seq": "",
    "a_user_id": "",
    "a_user_pw": "",
    "a_user_grade": "",
    "a_is_login": "1",
    "a_user_name": "",
    "a_user_nickname": "",
    "a_user_phone": "",
    "a_email":"",
  });
  useEffect(() => {
    
    if (props.isUpdate) {
      let changeRowData: any = {};
      for (let key in rowData) {
        if (props.rowData[key] != undefined) {
          changeRowData[key] = props.rowData[key];
        }
      }

      setRowData({
        ...rowData,
        ...changeRowData
      });
    }
  }, []);

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }

    setRowData({
      ...rowData,
      ...{ [name]: value }
    });
  };
  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    setRowData({
      ...rowData,
      ...{ [key]: date_str }
    });
  };

  const goWrite = (e: any) => {
    if (rowData.a_user_id == "") {
      alert("아이디 입력 필요.");
      return false;
    }
    if (rowData.a_user_name == "") {
      alert("이름 입력 필요.");
      return false;
    }
    if (props.isUpdate == false) {
      if (rowData.a_user_pw == "") {
        alert("암호 입력 필요.");
        return false;
      }
    }
    if (!window.confirm(pageData["confirm_msg"])) {
      return false;
    }

    let wRowData = { ...rowData };

    let formJsonData = {
      "data_arr": [wRowData],
      "is_default_val": "1",
      "is_update": "",
    };
    if (props.isUpdate) {
      formJsonData["is_default_val"] = "";
      formJsonData["is_update"] = "1";
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/write', formJsonData,get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          props.callback(response.data["data"]);
          props.closePopup();
        } else {
          alert(response.data["msg"]);
        }
      });

  };

  return (
    <div>
      <div className="write-table-div mt-1">
        <table>
          <colgroup>
            <col width="110px"></col>
            <col width="35%"></col>
            <col width="110px"></col>
            <col width="35%"></col>
          </colgroup>
          <tbody>
            <tr>
              <th>아이디</th>
              <td>
                <input type="text" className="row_input" value={rowData.a_user_id} name="a_user_id"
                  onChange={handleInputChange} />
              </td>
              <th>비번</th>
              <td>
                <input type="password" className="row_input" value={rowData.a_user_pw} name="a_user_pw"
                  onChange={handleInputChange} />
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input type="text" className="row_input" value={rowData.a_user_name} name="a_user_name"
                  onChange={handleInputChange} />
              </td>
              <th>닉네임</th>
              <td>
                <input type="text" className="row_input" value={rowData.a_user_nickname} name="a_user_nickname"
                  onChange={handleInputChange} />
              </td>
            </tr>
            <tr>
              <th>등급</th>
              <td>
                <select className="row_input" value={rowData.a_user_grade} name="a_user_grade"
                  onChange={handleInputChange} >
                  <option value="m">마스터</option>
                  <option value="u">회원</option>
                </select>
              </td>
              <th>로그인</th>
              <td>
                <select className="row_input" value={rowData.a_is_login} name="a_is_login"
                  onChange={handleInputChange} >
                  <option value="">아니오</option>
                  <option value="1">예</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>핸드폰</th>
              <td>
                <input type="text" className="row_input" value={rowData.a_user_phone} name="a_user_phone"
                  onChange={handleInputChange} />
              </td>
              <th>이메일</th>
              <td>
                <input type="text" className="row_input" value={rowData.a_email} name="a_email"
                  onChange={handleInputChange} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-box-center" style={{ marginTop: "10px" }}>
        <button className="btn btn_gray" onClick={goWrite}>{pageData["write_btn_text"]}</button>
        <button className="btn btn_gray" onClick={() => { props.closePopup(); }}>닫기</button>
      </div>
    </div>
  );
};
export default UserWritePopup;